var render = function () {
  var _vm$currentRound, _vm$currentRound2, _vm$currentRound3, _vm$currentRound3$col, _vm$currentRound3$col2, _vm$currentRound4, _vm$currentRound4$col, _vm$currentRound4$col2, _vm$currentRound5, _vm$currentRound6, _vm$currentRound6$mon, _vm$currentRound6$mon2, _vm$currentRound7, _vm$currentRound7$mon, _vm$currentRound7$mon2, _vm$currentRound8;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'on-the-stage',
      "customScrollContainerStyles": {
        background: '#000000'
      }
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    style: _vm.stageStyle,
    attrs: {
      "id": "curtain"
    }
  }, [_c('div', {
    attrs: {
      "id": "stage"
    }
  }, [_vm._l((_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : _vm$currentRound.musicians, function (musician, index) {
    var _musician$colorImage, _musician$colorImage$, _musician$colorImage2, _musician$colorImage3;
    return _c('figure', {
      key: ("musician" + index)
    }, [_c('figcaption', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: musician.name,
        expression: "musician.name"
      }],
      domProps: {
        "textContent": _vm._s(musician.name)
      }
    }), _c('img', {
      attrs: {
        "src": (_musician$colorImage = musician.colorImage) === null || _musician$colorImage === void 0 ? void 0 : (_musician$colorImage$ = _musician$colorImage.image) === null || _musician$colorImage$ === void 0 ? void 0 : _musician$colorImage$.src,
        "alt": (_musician$colorImage2 = musician.colorImage) === null || _musician$colorImage2 === void 0 ? void 0 : (_musician$colorImage3 = _musician$colorImage2.image) === null || _musician$colorImage3 === void 0 ? void 0 : _musician$colorImage3.description
      }
    })]);
  }), _c('figure', [_c('figcaption', {
    attrs: {
      "aria-hidden": "true",
      "id": "primary"
    }
  }, [_vm._v("Primary")]), _vm.completed && (_vm$currentRound2 = _vm.currentRound) !== null && _vm$currentRound2 !== void 0 && _vm$currentRound2.colorImage ? _c('img', {
    attrs: {
      "id": "color",
      "src": (_vm$currentRound3 = _vm.currentRound) === null || _vm$currentRound3 === void 0 ? void 0 : (_vm$currentRound3$col = _vm$currentRound3.colorImage) === null || _vm$currentRound3$col === void 0 ? void 0 : (_vm$currentRound3$col2 = _vm$currentRound3$col.image) === null || _vm$currentRound3$col2 === void 0 ? void 0 : _vm$currentRound3$col2.src,
      "alt": (_vm$currentRound4 = _vm.currentRound) === null || _vm$currentRound4 === void 0 ? void 0 : (_vm$currentRound4$col = _vm$currentRound4.colorImage) === null || _vm$currentRound4$col === void 0 ? void 0 : (_vm$currentRound4$col2 = _vm$currentRound4$col.image) === null || _vm$currentRound4$col2 === void 0 ? void 0 : _vm$currentRound4$col2.description
    }
  }) : _vm._e(), !_vm.completed && (_vm$currentRound5 = _vm.currentRound) !== null && _vm$currentRound5 !== void 0 && _vm$currentRound5.monochromeImage ? _c('img', {
    attrs: {
      "id": "bw",
      "src": (_vm$currentRound6 = _vm.currentRound) === null || _vm$currentRound6 === void 0 ? void 0 : (_vm$currentRound6$mon = _vm$currentRound6.monochromeImage) === null || _vm$currentRound6$mon === void 0 ? void 0 : (_vm$currentRound6$mon2 = _vm$currentRound6$mon.image) === null || _vm$currentRound6$mon2 === void 0 ? void 0 : _vm$currentRound6$mon2.src,
      "alt": (_vm$currentRound7 = _vm.currentRound) === null || _vm$currentRound7 === void 0 ? void 0 : (_vm$currentRound7$mon = _vm$currentRound7.monochromeImage) === null || _vm$currentRound7$mon === void 0 ? void 0 : (_vm$currentRound7$mon2 = _vm$currentRound7$mon.image) === null || _vm$currentRound7$mon2 === void 0 ? void 0 : _vm$currentRound7$mon2.description
    }
  }) : _vm._e()]), _c('div', {
    attrs: {
      "id": "dialog"
    }
  }, [_c('text-display-list', {
    attrs: {
      "element": "div",
      "id": "input",
      "text-size": "small"
    }
  }, _vm._l((_vm$currentRound8 = _vm.currentRound) === null || _vm$currentRound8 === void 0 ? void 0 : _vm$currentRound8.steps, function (step, stepIndex) {
    return _c('blinking-cursor-text', {
      key: ("step" + stepIndex),
      attrs: {
        "text": step.answer,
        "text-step": stepIndex
      }
    });
  }), 1)], 1)], 2)])])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }